import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { Environment } from '../../../environment';
import { AttentionLimits } from '../models/attention-limits.model';

@Injectable({
  providedIn: 'root',
})
export class AttentionLimitsService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.API_BASE_URL + '/service/herd/secure/attentionlimits';

  public get(): Observable<AttentionLimits> {
    return this.http.get<AttentionLimits>(`${this.baseUrl}`);
  }

  public getByDate(date: string): Observable<AttentionLimits> {
    return this.http.get<AttentionLimits>(`${this.baseUrl}?date=${date}`);
  }

  public post(attentionLimits: AttentionLimits): Observable<unknown> {
    return this.http.post(`${this.baseUrl}`, attentionLimits);
  }
}
